var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.7461V19.7461C17.5 18.6852 17.0786 17.6678 16.3284 16.9177C15.5783 16.1675 14.5609 15.7461 13.5 15.7461H5.5C4.43913 15.7461 3.42172 16.1675 2.67157 16.9177C1.92143 17.6678 1.5 18.6852 1.5 19.7461V21.7461",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.7461C11.7091 11.7461 13.5 9.95523 13.5 7.74609C13.5 5.53695 11.7091 3.74609 9.5 3.74609C7.29086 3.74609 5.5 5.53695 5.5 7.74609C5.5 9.95523 7.29086 11.7461 9.5 11.7461Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.746V19.746C23.4993 18.8597 23.2044 17.9987 22.6614 17.2983C22.1184 16.5978 21.3581 16.0975 20.5 15.876",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.87598C17.3604 4.09628 18.123 4.59668 18.6676 5.29829C19.2122 5.9999 19.5078 6.86281 19.5078 7.75098C19.5078 8.63915 19.2122 9.50206 18.6676 10.2037C18.123 10.9053 17.3604 11.4057 16.5 11.626",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_3200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.746094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.dce453da8c85e3accb7bfea5d284ce18.svg";
export { ForwardRef as ReactComponent };